import { useEffect, useRef } from 'react';

export const useDocumentTitle = (title: string, prevailOnUnmount = false) => {
  const defaultTitle = useRef(document.title);

  useEffect(() => {
    const defaultTitleCaptured = defaultTitle.current;
    document.title = title;
    return () => {
      if (!prevailOnUnmount && defaultTitleCaptured) {
        document.title = defaultTitleCaptured;
      }
    };
  }, [prevailOnUnmount, title]);
};
